import { render, staticRenderFns } from "./shiyanpingtai.vue?vue&type=template&id=75b6dcc4&scoped=true&"
import script from "./shiyanpingtai.vue?vue&type=script&lang=js&"
export * from "./shiyanpingtai.vue?vue&type=script&lang=js&"
import style0 from "./shiyanpingtai.vue?vue&type=style&index=0&id=75b6dcc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b6dcc4",
  null
  
)

export default component.exports